import ITestBeginState from './ITestBeginState';
import TestStartContext from './TestStartContext';
import TestStartDisplayType from './TestStartDisplayType';

class ErrorState implements ITestBeginState {
  private readonly context: TestStartContext;
  constructor(context: TestStartContext) {
    this.context = context;
  }
  performFunction(): void {
    this.context.setTestBeginState(TestStartContext.START);
  }
  getView(): TestStartDisplayType {
    return TestStartDisplayType.ERROR;
  }
}

export default ErrorState;
